/**
 * FSP values show with 2 decimals in the UI.
 * Filter by typed prefix:
 *   "5"   → SNF 5.00–5.99
 *   "5.1" → SNF 5.10–5.19
 *   "5.11" → SNF 5.11 only
 */

export const FSP_UI_DECIMALS = 2;
const HUNDREDTHS = 100;

export const roundFspForUi = (value) => {
  if (value === null || value === undefined || value === '') return null;
  const num = typeof value === 'number' ? value : parseFloat(String(value).trim());
  if (Number.isNaN(num)) return null;
  return Math.round(num * HUNDREDTHS) / HUNDREDTHS;
};

export const formatFspUiValue = (value) => {
  const rounded = roundFspForUi(value);
  if (rounded === null) return null;
  return rounded.toFixed(FSP_UI_DECIMALS);
};

export const countFilterDecimalPlaces = (input) => {
  const trimmed = String(input).trim();
  const dot = trimmed.indexOf('.');
  if (dot === -1) return 0;
  return trimmed.length - dot - 1;
};

export const getUiDisplayRangeForFilter = (filterStr) => {
  const trimmed = String(filterStr).trim();
  if (!trimmed) return null;
  const parsed = parseFloat(trimmed);
  if (Number.isNaN(parsed)) return null;

  const decimalPlaces = countFilterDecimalPlaces(trimmed);
  const bucketSize = 10 ** (FSP_UI_DECIMALS - decimalPlaces);
  const minHundredths = Math.round(parsed * 10 ** decimalPlaces) * bucketSize;
  const maxHundredths = minHundredths + bucketSize - 1;

  return {
    min: minHundredths / HUNDREDTHS,
    max: maxHundredths / HUNDREDTHS
  };
};

export const isValidFspFilterInput = (input) => {
  const trimmed = String(input).trim();
  return trimmed !== '' && !Number.isNaN(parseFloat(trimmed));
};

export const matchesUiFspValue = (value, filterStr) => {
  const range = getUiDisplayRangeForFilter(filterStr);
  if (!range) return false;
  const roundedValue = roundFspForUi(value);
  if (roundedValue === null) return false;
  return roundedValue >= range.min && roundedValue <= range.max;
};

export const parseFspNumber = (value) => roundFspForUi(value);

export const fspFilterPlaceholder = 'e.g. 5 or 5.1 (5.10–5.19)';
